// extracted by mini-css-extract-plugin
export var gridL = "grid-module--gridL--75c9b";
export var gridM = "grid-module--gridM--ad6cb";
export var gridOnly = "grid-module--gridOnly--44b00";
export var gridR = "grid-module--gridR--75c4b";
export var gridS = "grid-module--gridS--c5edc";
export var gridXL = "grid-module--gridXL--d2a63";